export var splashData = {
    body: {
        title: "Media library",
        image: {
            src: "https://sytbuildr.s3.eu-west-2.amazonaws.com/images/Email-Icons/emptymedialibrary.svg",
            alt: "empty-image",
            width: 80,
            height: 80,
        },
        subtitle: "Your media library is empty. Click the button below to add an image.",
    },
};
